import React from "react"
import {
  TeaserCarouselContainer,
  StandardTeaser,
  ReadMore,
  ExtendedCarousel,
} from "./style"
import useMedia from "hooks/useMedia.js"
import { MainColumn } from "components/MainColumn"

const TeaserCarousel = context => {
  const isMobile = useMedia(["(max-width: 767px)"], [true], false)
  const teasers = context.content.homeSettings.stories
  console.log("teasers:", teasers)

  return (
    <TeaserCarouselContainer id="stories">
      <MainColumn>
        <h2>CBR STORIES</h2>
      </MainColumn>
      <ExtendedCarousel
        gap={isMobile ? 15 : 40}
        slidesToShow={[1.1, 2.2, 3]}
        dotColor="#27B39D"
        draggable={true}
      >
        {teasers.map((teaser, index) => {
          if (teaser?.featureImage) {
            teaser.featuredImage.sizes = "(min-width: 1024px) 360px, 100vw"
          }

          if (teaser) {
            return (
              <StandardTeaser
                title={teaser.title}
                excerpt={teaser.excerpt}
                key={index}
                img={teaser.featuredImage}
              >
                <ReadMore to={teaser.link}>
                  <span>{teaser.label || "Read More"}</span>
                </ReadMore>
              </StandardTeaser>
            )
          }
        })}
      </ExtendedCarousel>
    </TeaserCarouselContainer>
  )
}

export default TeaserCarousel
